// 考核科目
<template>
  <div class="detail-wrap" style="overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          类型信息
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="checkSubjectEdit && formData.id!=null"
                     @click="update">
            保存
          </el-button>
        </div>
      </div>
      <div class="massing">

        <!-- 左边------- 树型结构 -->
        <div class="detail-wrap">
          <div class="user">

            <div class="user__tree">
              <div style="display:flex">
                <el-input placeholder="关键字过滤" v-model="filterText">
                </el-input>
                <el-button class="addBtn" type="primary" size="small"
                           v-if="checkSubjectAdd" @click="openAddTop"
                           style="margin-left: 10px; line-height: 8px; height: 28px;">添加
                </el-button>
              </div>

              <!-- 树型结构 -->
              <el-tree class="tree-line"
                       ref="tree"
                       :lazy="true"
                       :data="treeData"
                       :props="{ label: 'name', children: 'children', isLeaf: 'leaf', dataId: 'dataId', }"
                       :load="loadNode"
                       node-key="id"
                       @node-click="nodeClick"
                       :filter-node-method="filterNode"
                       v-if="showTree"
              >
                <div class="comp-tr-node" slot-scope="{ node, data }" style="position: relative;">
                  <template>
                    <!-- 名称： 新增节点增加class（is-new） -->
                    <span class="node_width">{{ node.label }} </span>
                    <!-- 按钮 -->
                    <span style="position: absolute;top: -6px;left: 85px;">
                        <!-- 新增 -->
                        <el-button type="text" v-if="checkSubjectAdd" size="mini"
                                   @click.stop="() => append(node)">
                          <i slot="default" class="el-icon-circle-plus"></i>
                        </el-button>
                      </span>
                  </template>
                </div>
              </el-tree>


              <div class="tree-box">
                <el-dialog style="padding: 40px 20px"
                           :close-on-click-modal="false"
                           :visible.sync="addDialogVisible"
                           width="55%" top="5vh"
                           :show-close="true"
                           :before-close="addHandleClose"
                           title="新增"
                >
                  <el-form :model="formData1" label-width="140px" ref="addRef" :rules="elRules">
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="考核编码" prop="code">
                          <el-input size="medium" :maxlength="20" v-model="formData1.code" placeholder="考核编码"
                                    style="width: 10vw;"/>
                        </el-form-item>
                      </el-col>
                      <el-col span="1"></el-col>
                      <el-col span='10'>
                        <el-form-item label="考核名称" prop="name">
                          <el-input size="medium"  v-model="formData1.name" placeholder="考核名称"
                                    style="width: 10vw;"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="上级科目" prop="parentName">
                          <span
                            style="font-size: 12px; font-weight: 400;width:10vw">{{
                              formData1.parentName ? formData1.parentName : '无'
                            }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col span="1"></el-col>
                      <el-col span='10'>
                        <el-form-item label="考核类型" prop="checkType">
                          <el-select v-model="formData1.checkType" style="width: 10vw;">
                            <el-option label="奖励" :value="2"/>
                            <el-option label="处罚" :value="1"/>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="使用场景">
                          <el-select v-model="formData1.useWhere" style="width: 10vw;">
                            <el-option label="审单" :value="1"/>
                            <el-option label="回访" :value="2"/>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col span="1"></el-col>
                      <el-col span='10'>
                        <el-form-item label="是否需要网点申诉" prop="isNeedSiteComplain">
                          <el-select v-model="formData1.isNeedSiteComplain" style="width: 10vw;">
                            <el-option label="否" :value="0"/>
                            <el-option label="是" :value="1"/>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="费用名称" :rules="{required: true}">
                          <companyFeeAttributeSelect :company-fee-attribute-id.sync="formData1.feeAttributeId"
                                                     style="width: 10vw;"/>
                        </el-form-item>
                      </el-col>
                      <el-col span="1"></el-col>
                      <el-col span='10'>
                        <el-form-item label="考核金额">
                          <el-input type="number" autocomplete="off" v-model="formData1.standardAmount" clearable
                                    style="width: 10vw;"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="是否并处考核" :rules="{required: true}">
                          <el-select v-model="formData1.isAddSubject" style="width: 10vw;">
                            <el-option label="否" :value="0"/>
                            <el-option label="是" :value="1"/>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col span="1"></el-col>

                      <el-col span='10'>
                        <el-form-item label="申诉期(天)">
                          <el-input type="number" autocomplete="off" v-model="formData1.complaintDates" clearable
                                    style="width: 10vw;"/>
                        </el-form-item>
                      </el-col>

                    </el-row>
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="新服务商免考核科目">
                          <el-select v-model="formData1.uncheckSubject" style="width: 10vw;">
                            <el-option label="否" :value="0"/>
                            <el-option label="是" :value="1"/>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col span="1"></el-col>

                      <el-col span='10'>
                        <el-form-item label="新服务商免考核期(天)">
                          <el-input type="number" min="0" max="99" autocomplete="off"
                                    v-model="formData1.uncheckSubjectDates" clearable style="width: 10vw;"/>
                        </el-form-item>
                      </el-col>


                    </el-row>
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="排序" prop="seq">
                          <el-input type="number" min="0" max="99" autocomplete="off" v-model="formData1.seq" clearable
                                    style="width: 10vw;"/>
                        </el-form-item>
                      </el-col>
                      <el-col span="1"></el-col>
                      <el-col span='10'>
                        <el-form-item label="是否需要总部审核">
                          <el-select v-model="formData1.needCompanyCheck" style="width: 10vw;">
                            <el-option label="否" :value="0"/>
                            <el-option label="是" :value="1"/>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="启用" prop="usable">
                          <el-select v-model="formData1.usable" style="width: 10vw;">
                            <el-option label="禁用" :value="0"/>
                            <el-option label="启用" :value="1"/>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col span='10'>
                        <el-form-item label="申诉提示" prop="usable">
                          <el-input class="annotate" type="textarea" :rows="1" size="small"
                                    v-model="formData1.siteAnswerPrompt" clearable></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
<!--                    <el-row>-->
<!--                      <el-col span="10">-->
<!--                        <el-form-item label="是否并处考核">-->
<!--                          <el-select v-model="formData1.isAddSubject" style="width: 10vw;">-->
<!--                            <el-option label="否" :value="0"/>-->
<!--                            <el-option label="是" :value="1"/>-->
<!--                          </el-select>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                  <el-button size="small" @click="closeAddDialog">取 消</el-button>
                  <el-button size="small" type="primary" @click="addTreeNode">确 定</el-button>
                </span>
                </el-dialog>
              </div>
            </div>


          </div>
        </div>


        <div class="detail-wrap" style="height: 100vh;width: calc(100% - 315px);background-color: #fff;">

          <div>
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first" style="border-top: 1px solid #ededed;">
                  <b>主信息</b>
                </div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      考核编码：
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" style="width:7vw" v-model="formData.code" clearable/>
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      考核名称：
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" style="width:7vw" v-model="formData.name" clearable/>
                    </td>
                    <th>上级考核科目：</th>
                    <td>
                      <span
                        style="font-size: 12px; font-weight: 400">{{
                          formData.parentName ? formData.parentName : '无'
                        }}</span>
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      考核类型：
                    </th>
                    <td>
                      <el-select v-model="formData.checkType" style="width:7vw">
                        <el-option label="奖励" :value="2"/>
                        <el-option label="处罚" :value="1"/>
                      </el-select>
                    </td>
                  </tr>
                  <div style="height:15px"></div>
                  <tr>

                    <th>使用场景：</th>
                    <td>
                      <el-select v-model="formData.useWhere" style="width:7vw">
                        <el-option label="审单" :value="1"/>
                        <el-option label="回访" :value="2"/>
                      </el-select>
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      是否需要网点申诉：
                    </th>
                    <td>
                      <el-select v-model="formData.isNeedSiteComplain" style="width:7vw">
                        <el-option label="否" :value="0"/>
                        <el-option label="是" :value="1"/>
                      </el-select>
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      费用名称：
                    </th>
                    <td>
                      <companyFeeAttributeSelect style="width:7vw"
                                                 :company-fee-attribute-id.sync="formData.feeAttributeId"
                      />
                    </td>

                    <th>考核金额：</th>
                    <td>
                      <el-input type="number" autocomplete="off" style="width:7vw" v-model="formData.standardAmount"
                                clearable/>
                    </td>
                  </tr>

                  <div style="height:15px"></div>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      是否并处考核：
                    </th>
                    <td>
                      <el-select v-model="formData.isAddSubject" style="width:7vw">
                        <el-option label="否" :value="0"/>
                        <el-option label="是" :value="1"/>
                      </el-select>
                    </td>
                    <th>申诉期(天)：</th>
                    <td>
                      <el-input type="number" autocomplete="off" style="width:7vw" v-model="formData.complaintDates"
                                clearable/>
                    </td>

                    <th>新服务商免考核科目：</th>
                    <td>
                      <el-select v-model="formData.uncheckSubject" style="width:7vw">
                        <el-option label="否" :value="0"/>
                        <el-option label="是" :value="1"/>
                      </el-select>
                    </td>

                    <th>新服务商免考核期(天)：</th>
                    <td>
                      <el-input type="number" autocomplete="off" style="width:7vw"
                                v-model="formData.uncheckSubjectDates" min="0" max="999"
                                clearable/>
                    </td>
                    <!--
                                        <th><em class="f-red">*</em>排序：</th>
                                        <td>
                                          <el-input type="number" autocomplete="off" style="width:7vw" v-model="formData.seq"
                                                    clearable/>
                                        </td> -->
                  </tr>
                  <div style="height:15px"></div>

                  <tr>

                    <th><em class="f-red">*</em>排序：</th>
                    <td>
                      <el-input type="number" autocomplete="off" style="width:7vw" v-model="formData.seq"
                                clearable/>
                    </td>
                    <th><em class="f-red"></em>是否需要总部审核：</th>
                    <td>
                      <el-select v-model="formData.needCompanyCheck" style="width:7vw">
                        <el-option label="否" :value="0"/>
                        <el-option label="是" :value="1"/>
                      </el-select>
                    </td>
                    <th><em class="f-red">*</em>启用：</th>
                    <td>
                      <el-select v-model="formData.usable" style="width:7vw">
                        <el-option label="禁用" :value="0"/>
                        <el-option label="启用" :value="1"/>
                      </el-select>
                    </td>

<!--                    <th>是否并处考核</th>-->
<!--                    <td>-->
<!--                      <el-select v-model="formData.isAddSubject" style="width:7vw">-->
<!--                        <el-option label="否" :value="0"/>-->
<!--                        <el-option label="是" :value="1"/>-->
<!--                      </el-select>-->
<!--                    </td>-->
                  </tr>
                  <div style="height:15px"></div>

                  <tr>
                    <th>申诉提示：</th>
                    <td colspan="15"> <el-input class="annotate" type="textarea" :rows="1" size="small"
                                   v-model="formData.siteAnswerPrompt" clearable></el-input></td>
                  </tr>

                  <div style="height:15px"></div>
                  <tr class="pop_time">
                    <th>创建人：</th>
                    <td>{{ formData.createBy }}</td>
                    <th>创建时间：</th>
                    <td>{{ formData.createTime }}</td>
                  </tr>
                  <div style="height:15px"></div>
                  </tbody>
                </table>

              </div>

            </div>

            <div style="height: 50px;"></div>
          </div>


        </div>


      </div>
    </el-form>

  </div>
</template>

<script>
import photoUpload from "@/components/formItem/photoUpload.vue"
import {mapGetters} from "vuex";
import ExcelUpload from "@/components/upload/excel";
import api from "@/api/projectApi";
import companyFeeAttributeSelect from "@/components/formItem/companyFeeAttributeSelect.vue"

export default {
  name: "check",
  components: {
    ExcelUpload, photoUpload,
    companyFeeAttributeSelect
  },
  data() {
    return {
      checkSubjectAdd: false,
      checkSubjectEdit: false,
      type: null,
      showAddDialog: false,
      currentNode: null,
      showTree: true,
      temp: null,

      processId: null,
      showPreconditionDialog: false,
      activeName: 'first',
      isShowEdit: false,
      getTreeDataUrl: '/basic/basServiceType/getList',
      treeData: [],
      topServiceTypeOptions: [{label: '无父类', value: '0'}],
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
        dataId: 'dataId',
      },

      requestParam: {
        businessType: 0,
        settleType: 0,
        parentId: '',
        serviceTypeName: null,
        usable: 1,
        siteAnswerPrompt:''
      },
      tableData: [],
      formData: {
        code: null,  // 考核编码,同厂商下惟一
        name: null,  // 考核名称
        parentId: null,  // 上级考核科目ID,关联bas_check_subject.id
        checkType: 1,  // 考核类型:1处罚;2奖励
        useWhere: null,  // 使用场景:1审单;2回访
        isNeedSiteComplain: 1,  // 是否需要网点申诉:0否1是
        feeAttributeId: null,  // 费用名称ID,关联sn_company_fee_attribute.id
        standardAmount: 0,  // 考核金额
        complaintDates: 0,  // 申诉期(天);即超过申诉期后系统自动强制执行考核
        uncheckSubject: 0,  // 新服务商免考核科目;0否1是
        uncheckSubjectDates: 0,  // 新服务商免考核期(天)
        seq: 0,  // 排序
        usable: 1,  // 启用:0禁用；1启用
        isAddSubject: 0,
        siteAnswerPrompt:''
      },
      formData1: {
      },
      elRules: {
        code: [{required: true}],
        name: [{required: true}],
        checkType: [{required: true}],
        isNeedSiteComplain: [{required: true}],
        seq: [{required: true}],
        usable: [{required: true}],
      },
      rules: {
        code: [{prop: '考核编码', required: true, type: 'string', maxlength: 15,}],
        name: [{prop: '考核名称', required: true, type: 'string', }],
        parentId: [{prop: '上级考核科目', required: false,}],
        checkType: [{prop: '考核类型', required: true, type: 'number', max: 99,}],
        useWhere: [{prop: '使用场景', required: false, type: 'number', max: 99,}],
        isNeedSiteComplain: [{prop: '是否需要网点申诉', required: true, type: 'number', max: 99,}],
        feeAttributeId: [{prop: '费用名称', required: true,}],
        standardAmount: [{prop: '考核金额', required: false, type: 'number', max: 9999.99,}],
        complaintDates: [{prop: '申诉期(天)', required: false, type: 'number', max: 999,}],
        uncheckSubject: [{prop: '新服务商免考核科目', required: false, type: 'number', max: 99,}],
        uncheckSubjectDates: [{prop: '新服务商免考核期(天)', required: false, type: 'number', max: 999,}],
        seq: [{prop: '排序', required: true, type: 'number', max: 99,}],
        isAddSubject: [{prop: '是否并处考核', required: true,}],
        usable: [{prop: '启用:0禁用；1启用', required: true, type: 'number', max: 99,}],
      },

      refreshThePicture: true,


      disabledCategoryType: false,
      isRouterAlive: true,
      is_new: false,
      // 以上大小ID  类型信息
      filterText: '',
      addType: 1,
      addNode: '',
      _node_level: '',
      NODE_KEY: "id", // id对应字段
      MAX_LEVEL: 2, // 设定最大层级
      NODE_ID_START: 0, // 新增节点id，逐次递减
      startId: null,
      addDataList: "",
      addForm: {
        name: "",
        code: ""
      },

      addDialogTitle: "new",
      addDialogVisible: false,

      searchForm: {},
      tree: {
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 1,
        usable: 1
      },
      list: [],
      listLoading: true,
      form: {},
      rolesOptions: [],
      postOptions: [],
      excelUpload: false,

    };
  },
  computed: {
    api() {
      return api
    },
    ...mapGetters(["permissions"]),
  },

  created() {
    this.checkSubjectEdit = this.permissions['check_subject_edit']
    this.checkSubjectAdd = this.permissions['check_subject_add']
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },

  },

  methods: {

    // 节点加载
    loadNode(node, resolve) {
      if (node.level === 0) {// 根节点，父id为0
        this.requestTreeData(0, resolve)
      } else {
        this.requestTreeData(node.data.id, resolve)
      }
    },

    // 树形控件数据请求
    requestTreeData(parentId, resolve) {
      this.$http.post(api.basCheckSubject.getTreeData, {parentId: parentId}).then(res => {
        resolve(res.data.data.map(item => {
          return {id: item.id, name: item.name, leaf: !item.hasChild}
        }))
      })
    },

    // 节点点击回显
    nodeClick(data) {
      console.log(data, 'click')
      this.currentNode = data
      this.$http.post(api.basCheckSubject.getDataUrl, {id: data.id}).then(res => {
        this.formData = res.data.data
        if (this.formData.useWhere == 0) {
          this.formData.useWhere = null
        }
      })
    },


    append(node) {
      this.addDialogVisible = true  // 显示新增弹框
      this.temp = node.data
      this.type = 'child'
      this.formData1 = this.reset()
      this.formData1.parentName = this.temp.name
    },


    addTreeNode() {
      this.$validate(this.formData1, this.rules).then(() => {
        if (this.type === 'top') {
          this.$mask.open()

          this.$http.post(api.basCheckSubject.addDataUrl, this.formData1).then(res => {
            let id = res.data.data
            this.treeData.push({
              leaf: true,
              name: this.formData1.name,
              id: id,
              nodeKey: id
            })
            this.$message.success('保存成功')
            this.addDialogVisible = false
            this.$mask.close()


          }).catch(() => {
            this.$mask.close()
          })
        } else if (this.type === 'child') {
          this.$mask.open()

          this.formData1.parentId = this.temp.id
          this.$http.post(api.basCheckSubject.addDataUrl, this.formData1).then(res => {
            let id = res.data.data
            if (this.temp.leaf) {
              this.showTree = false
              setTimeout(() => {
                this.showTree = true
              }, 50)
            } else {
              this.$refs.tree.append({
                leaf: true,
                name: this.formData1.name,
                id: id,
              }, this.temp.id)
            }
            this.$message.success('保存成功')
            this.addDialogVisible = false
            this.$mask.close()

          }).catch(() => {
            this.$mask.close()
          })
        }
      })
    },

    closeAddDialog() {
      this.addDialogVisible = false
    },


    addHandleClose() {
      this.addDialogVisible = false;
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },


    // 新增顶级结点
    openAddTop() {
      this.addDialogVisible = true;
      this.formData1 = this.reset()
      this.type = 'top'
    },


    update() {
      this.$validate(this.formData, this.rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          if (this.formData.useWhere == null) {
            this.formData.useWhere = 0
          }
          this.$http.post(api.basCheckSubject.updateDataUrl, this.formData).then(res => {
            this.$message.success('修改成功')
            let tree = this.$refs.tree;
            tree.insertAfter({id: -1, name: '加载中', leaf: true}, this.currentNode.id)
            tree.remove(this.currentNode.id)
            tree.insertAfter({id: this.formData.id, name: this.formData.name, leaf: this.currentNode.leaf}, -1)
            tree.remove(-1)
          })
        })
      })
    },

    reset() {
      return {
        code: null,  // 考核编码,同厂商下惟一
        name: null,  // 考核名称
        parentId: null,  // 上级考核科目ID,关联bas_check_subject.id
        checkType: 1,  // 考核类型:1处罚;2奖励
        useWhere: null,  // 使用场景:1审单;2回访
        isNeedSiteComplain: 1,  // 是否需要网点申诉:0否1是
        feeAttributeId: null,  // 费用名称ID,关联sn_company_fee_attribute.id
        standardAmount: 0,  // 考核金额
        complaintDates: 0,  // 申诉期(天);即超过申诉期后系统自动强制执行考核
        uncheckSubject: 0,  // 新服务商免考核科目;0否1是
        uncheckSubjectDates: 0,  // 新服务商免考核期(天)
        seq: 0,  // 排序
        usable: 1,  // 启用:0禁用；1启用
        needCompanyCheck: 0,
        isAddSubject: 0,
        siteAnswerPrompt:''
      }
    },


  },

};

</script>

<style lang="scss" scoped>
.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}


.is_new {
  display: none
}

.d-item {
  border-left: 1px solid #ededed;
}

.el-main {
  display: inline-block;
  height: 791.18px;
}

::v-deep .el-card__body,
.el-main {
  padding: 6px 8px;
  margin: 10px 5px 0px 12px;
  border: 1px solid #ededed;
}

.basic-container {
  padding: 0px 0px 8px 0px !important;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;

  tr th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);


  }
}

.pop_time {
  td {
    font-weight: 400;
    text-align: left;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.massing {
  display: flex;
  // height: calc(100vh - 94px);

}

.detail-wrap .d-header {
  border-bottom: solid 1px #E9E9E9;
  height: 34px;
  line-height: 34px;
  margin: 7px 0px 6px 12px;
  padding: 0px 24px 0 14px;
  font-size: 13px;
  overflow: hidden;
  background-color: #FFF;
}

.detail-wrap .d-header .fl > i {
  color: #00c4b3;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  margin-bottom: 1px;
  font-size: 14px;
  font-size: 14px;
}

.d-cont {
  border-bottom: 1px solid #ededed;
  padding-top: 10px;

}

::v-deep[data-v-43ab9747] .el-card__body, .el-main[data-v-43ab9747] {
  padding: 6px 8px;
  border: 1px solid #ededed;
  margin-top: 10px;
  margin-left: 12px;
  margin-right: 5px;
}

.user {
  background-color: #fff;
  margin-left: 12px;
  margin-top: 10px;
  margin-right: 5px;
  height: 100%;
  border: 1px solid #ededed;
  padding-top: 10px;
  padding-left: 5px;
  // width: 100%;
  .tree-box {
    width: 100%;
    height: 80%;
    overflow: auto;
    border: none !important;;
  }

  &__tree {
    // padding: 15px;
    // border: 1px solid #ededed;
    width: 100%;
    height: 80%;
  }

  &__main {
    .el-card__body {
      padding-top: 0;
    }
  }
}


// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 45px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.basic-container .el-card {
  width: 100%;
  height: 800px;
}


.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep.el-tree {
  border: 1px solid #ededed;
  // width: calc(100% - 32px);
  // overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  width: 245px;
  overflow: scroll;
  //overflow-y: hidden;
  color: rgba(86, 86, 86, 0.96);
}


// 重新修改tree组件样式
.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;
    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

// 图片
.pic_total {
  margin-left: 45px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 15px;

  ::v-deep .table-detail.el-upload--picture-card {
    margin: 20px auto !important;
    // margin-left: 30%;
    width: 60px !important;
    height: 60px !important;
    line-height: 65px !important;
  }

  ::v-deep.el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
    width: 60px !important;
    height: 60px !important;
    padding: 0 !important;
  }

  ::v-deep .el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 60px !important;
    height: 60px !important;
    margin-right: 0px !important;
    border-radius: 2px;
    padding: 0px !important;
    border-color: #e8e8e8;
    margin-top: 20px;
    margin-bottom: 10px;
    margin-left: 80%;
  }

  .pic_total_items {
    width: 21%;
    border: 1px solid #e3e3e3;
    height: 200px;
    margin-right: 20px;
    margin-bottom: 20px;

    .pic_p {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      p {
        font-size: 12px;
        font-weight: 400;
        width: 110px;
        text-align: right;
        color: #606266;
        display: inline-block;
        word-wrap: break-word;
        white-space: normal;
      }


    }

  }

  .form_pic {
    width: 39%;
    margin-top: 5px;
    margin-left: 2px;
  }

  .form_ename {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    // width: 80%;
    // margin-left: 10%;
    // margin-top: -25px;

    span {
      font-size: 12px;
      font-weight: 400;
      width: 115px;
      line-height: 28px;
      text-align: right;
      color: #606266;
      display: inline-block;
      word-wrap: break-word;
      white-space: normal;
    }
  }
}

::v-deep .el-upload--picture-card {
  margin: 20px auto !important;

  // margin-left: 30%;
  width: 60px !important;
  height: 60px !important;
  line-height: 65px !important;
}

.el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px !important;
  height: 60px !important;
  padding: 0 !important;
}

.el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 60px !important;
  height: 60px !important;
  margin-right: 0px !important;
  border-radius: 2px;
  padding: 0px !important;
  border-color: #e8e8e8;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: 80%;
}

.table-detail {
  padding: 0 10px;
  display: inline-block;

  tr {

    // margin-bottom: 10px;
    th {
      font-weight: 400;
      text-align: right;
      width: 9vw !important;
      font-size: 12px;
      position: relative;
      padding: 0 10px 0 4px;
      color: rgba(86, 86, 86, 0.96);


    }
  }
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

::v-deep.el-tree-node > .el-tree-node__children {
  overflow: visible !important
}

::v-deep .el-tree-node > .el-tree-node__children {

  overflow: visible !important
}

// {
//     padding-left: 16px;
//     overflow: visible!important
// }
.node_width{
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
   text-overflow: ellipsis;
   width: 80px;
}
</style>
